const MAX_SLUG_LENGTH = 63;

/** Derive a URL-safe organisation slug from a display name. */
export function slugifyOrganisationName(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .slice(0, MAX_SLUG_LENGTH)
    .replace(/^-+|-+$/g, '');
}
